import React from 'react';
import {
  FaBirthdayCake,
  FaBriefcase,
  FaBuilding,
  FaBusinessTime,
  FaCheck,
  FaCouch,
  FaExclamationTriangle,
  FaFacebookSquare,
  FaGlassCheers,
  FaHeart,
  FaHome,
  FaInstagram,
  FaLinkedin,
  FaThumbsUp,
  FaTiktok,
  FaUniversity,
} from 'react-icons/fa';
import _ from 'lodash';
import {
  FaCheck as FaCheckThin,
  FaCakeCandles,
  FaCalendarCheck,
  FaPeopleGroup,
  FaPersonRunning,
  FaXTwitter,
  FaQuestion,
  FaEnvelope,
  FaGift,
  FaClover,
  FaFaceFrown,
  FaPersonPregnant,
} from 'react-icons/fa6';
import { PiNotificationBold } from 'react-icons/pi';
import { AiOutlineClose } from 'react-icons/ai';
import { FiPhone, FiMapPin, FiLink } from 'react-icons/fi';
import { HiOutlineEnvelope } from 'react-icons/hi2';
import { BsTextParagraph } from 'react-icons/bs';
import { MdOutlineQuiz } from 'react-icons/md';
import { BiRename } from 'react-icons/bi';
import { ProfileDataType, SocialType } from '../types/Profile';
import { CommunityType } from '../types/community';
import { BusinessType } from '../types/business';
import { EventParticipationAnswer, EventType } from '../types/event';
import { CustomFieldType } from '../models/inviteService.model';
import { CommunicationType } from '../types/communication';

export const profileDataTypeIcons = {
  [ProfileDataType.ADDRESS]: (
    <FiMapPin className="icon h-6 w-5" aria-hidden="true" strokeWidth="2" />
  ),
  [ProfileDataType.BIRTHDATE]: <FaCakeCandles className="icon h-5 w-5" aria-hidden="true" />,
  [ProfileDataType.EMAIL]: (
    <HiOutlineEnvelope className="icon h-5 w-5" strokeWidth="2" aria-hidden="true" />
  ),
  [ProfileDataType.PHONENUMBER]: <FiPhone className="h-5 w-5" strokeWidth="2" aria-hidden="true" />,
  [ProfileDataType.BUSINESSNAME]: (
    <FaBuilding className="h-5 w-5" strokeWidth="2" aria-hidden="true" />
  ),
  [ProfileDataType.SOCIAL]: <FiLink className="icon h-5 w-5" strokeWidth="2" aria-hidden="true" />,
};

export const customFieldTypeIcons = {
  [CustomFieldType.TEXT]: <BsTextParagraph className="h-5 w-5 flex-shrink-0" />,
  [CustomFieldType.MULTIPLE_CHOICE]: <MdOutlineQuiz className="h-5 w-5 flex-shrink-0" />,
  [CustomFieldType.COMMUNICATION_NAME]: <BiRename className="h-5 w-5 flex-shrink-0" />,
};

export const communityTypeIcons = {
  [CommunityType.OTHER_COMMUNITY]: FaCheck,
  [CommunityType.ROOMMATES]: FaHome,
  [CommunityType.STUDENTGROUP]: FaUniversity,
  [CommunityType.SPORTTEAM]: FaPersonRunning,
  [CommunityType.ASSOCIATION]: FaPeopleGroup,
  [CommunityType.COLLEAGUES]: FaBusinessTime,
  [CommunityType.FRIENDS]: FaGlassCheers,
  [CommunityType.FAMILY]: FaHeart,
};

export const businessTypeIcons = {
  [BusinessType.SPORTCLUB]: FaPersonRunning,
  [BusinessType.STUDENTASSOCIATION]: FaUniversity,
  [BusinessType.OTHER_BUSINESS]: FaBusinessTime,
};

export const eventTypeIcons = {
  [EventType.SOCIAL]: FaPeopleGroup,
  [EventType.WORK]: FaBriefcase,
  [EventType.SPORT]: FaPersonRunning,
  [EventType.OTHER]: FaCalendarCheck,
};

export const socialTypeIcons = {
  [SocialType.FACEBOOK]: <FaFacebookSquare className="icon h-5 w-5" aria-hidden="true" />,
  [SocialType.LINKEDIN]: <FaLinkedin className="icon h-5 w-5" aria-hidden="true" />,
  [SocialType.X]: <FaXTwitter className="icon h-5 w-5" aria-hidden="true" />,
  [SocialType.TIKTOK]: <FaTiktok className="icon h-5 w-5" aria-hidden="true" />,
  [SocialType.INSTAGRAM]: <FaInstagram className="icon h-5 w-5" aria-hidden="true" />,
};
export const eventParticipantAnswerIcons = {
  [EventParticipationAnswer.YES]: FaCheckThin,
  [EventParticipationAnswer.MAYBE]: FaQuestion,
  [EventParticipationAnswer.NO]: AiOutlineClose,
  [EventParticipationAnswer.PENDING]: FaExclamationTriangle,
};

export const communicationTypeIcons = {
  [CommunicationType.EMAIL]: HiOutlineEnvelope,
  [CommunicationType.NOTIFICATION]: PiNotificationBold,
  [CommunicationType.POSTCARD]: FaEnvelope,
};

export const communityInvitePropertyTypeIcons = {
  ..._.omit(profileDataTypeIcons, ProfileDataType.SOCIAL),
  ...socialTypeIcons,
};

export const postcardTemplateCategoryIcon = (category: string) => {
  switch (category) {
    case 'valentine':
      return FaHeart;
    case 'birthday':
      return FaBirthdayCake;
    case 'congratulation':
      return FaGift;
    case 'newjob':
      return FaBriefcase;
    case 'pregnant':
      return FaPersonPregnant;
    case 'thankyou':
      return FaThumbsUp;
    case 'goodluck':
      return FaClover;
    case 'getwell':
      return FaCouch;
    case 'condolences':
      return FaFaceFrown;
    case 'communities':
      return FaPeopleGroup;
    default:
      return FaGift;
  }
};
